/* Nordic Sheep PL – „Kup więcej, zyskaj więcej” (Horizon) · v2.5 (port z NL 2026-09-23)
   Drabinka (kumulatywna, liczy WSZYSTKIE produkty oprócz szczotki-prezentu):
   2 = szczotka gratis · 3 = + darmowa dostawa · 4 = + dodatkowe 10% rabatu.
   Rabaty to automatyczne rabaty Shopify; ten skrypt dodaje (i usuwa) darmową szczotkę w koszyku
   oraz aktualizuje boksy drabinki (PDP + koszyk).
   v2: prezent jest przetwarzany ZANIM Horizon dostanie odpowiedź, a sekcje w odpowiedzi są
   zastępowane świeżym HTML → szuflada/numery linii nigdy się nie rozjeżdżają.
   v2.1: refreshUI wysyła świeży HTML sekcji (pusta szuflada → pełna szuflada działa).
   v2.2: event-cart przez CartLinesUpdateEvent.createCartFromAjaxResponse (standard-events oczekuje cart.lines).
   v2.4: drabinka 10% (rabat na cenach produktów dotyczy tylko cen/compare-at).
   v2.5: „prezent usunięty” zapamiętuje liczbę produktów w tym momencie i obowiązuje tylko, dopóki
         nie dojdzie więcej produktów. */
const BRUSH_VARIANT = 55472044769622;
const GIFT_MIN = 2;
/* v2.7 (22-10-2026): børsten udsolgt/kladde → ingen gave; trappen bliver 2 = gratis verzending, 4 = 10%. */
const GIFT_ON = window.nsGiftOn !== false;
const KEY_DISMISS = 'nsGiftDismissedAt';
const H = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-NS-Gift': '1' };
const origFetch = window.fetch.bind(window);

let lastCart = null;
let running = null;
let again = false;

const isGift = (it) => it.variant_id === BRUSH_VARIANT && it.properties && it.properties._free_gift;
const qualifying = (cart) => cart.items.filter((it) => !isGift(it)).reduce((s, it) => s + it.quantity, 0);
const isDismissed = (q) => { try { const v = sessionStorage.getItem(KEY_DISMISS); return v !== null && q <= Number(v); } catch (e) { return false; } };
const setDismissed = (q) => { try { sessionStorage.setItem(KEY_DISMISS, String(q)); } catch (e) {} };
const clearDismissed = () => { try { sessionStorage.removeItem(KEY_DISMISS); sessionStorage.removeItem('nsGiftDismissed'); } catch (e) {} };

async function getCart() {
  const r = await origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  lastCart = await r.json();
  return lastCart;
}
function post(url, body) {
  return origFetch(url, { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify(body) });
}

async function reconcileOnce() {
  const cart = await getCart();
  const q = qualifying(cart);
  const gifts = cart.items.filter(isGift);
  let changed = false;
  if (!GIFT_ON) {
    for (const g of gifts) { await post('/cart/change.js', { id: g.key, quantity: 0 }); changed = true; }
    if (changed) await getCart();
    return changed;
  }
  if (q < GIFT_MIN) clearDismissed();
  if (q >= GIFT_MIN && !isDismissed(q)) {
    if (!gifts.length) {
      await post('/cart/add.js', { items: [{ id: BRUSH_VARIANT, quantity: 1, properties: { _free_gift: '1' } }] });
      changed = true;
    } else {
      for (const g of gifts.slice(1)) { await post('/cart/change.js', { id: g.key, quantity: 0 }); changed = true; }
      if (gifts[0].quantity !== 1) { await post('/cart/change.js', { id: gifts[0].key, quantity: 1 }); changed = true; }
    }
  } else if (q < GIFT_MIN && gifts.length) {
    for (const g of gifts) await post('/cart/change.js', { id: g.key, quantity: 0 });
    changed = true;
  }
  if (changed) await getCart();
  return changed;
}

function reconcile() {
  if (running) { again = true; return running; }
  running = (async () => {
    let changed = false;
    do {
      again = false;
      try { changed = (await reconcileOnce()) || changed; } catch (e) { console.warn('[ns-gift]', e); }
    } while (again);
    return changed;
  })().then((changed) => { running = null; updateLadder(); return changed; });
  return running;
}

function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
}
async function freshSections(ids) {
  if (!ids.length) return null;
  const r = await origFetch(`${location.pathname}?sections=${ids.join(',')}`, { credentials: 'same-origin' });
  return r.json();
}

/* Niech Horizon przerenderuje (szuflada + ikona koszyka) bez automatycznego otwierania szuflady. */
async function refreshUI() {
  await getCart();
  const count = lastCart.item_count;
  try {
    const sections = await freshSections(cartSectionIds());
    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const cart = CartLinesUpdateEvent.createCartFromAjaxResponse(Object.assign({}, lastCart));
    const promise = Promise.resolve({ cart, detail: { sections: sections || undefined, items: lastCart.items, itemCount: count, source: 'ns-gift', didError: false } });
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise }));
    await promise;
    setTimeout(updateLadder, 400);
  } catch (e) {
    console.warn('[ns-gift] refreshUI', e);
    if (location.pathname.indexOf('/cart') === 0) location.reload();
  }
}

async function openDrawer() {
  await refreshUI();
  const d = document.getElementById('cart-drawer');
  if (d && typeof d.open === 'function' && location.pathname.indexOf('/cart') !== 0) {
    setTimeout(() => d.open(), 250);
  } else {
    location.href = '/cart';
  }
}

/* Szanuj ręczne usunięcie prezentu – ale tylko dopóki nie dojdą nowe produkty. */
function noteDismiss(init) {
  if (!init || !init.body || !lastCart) return;
  let b = init.body;
  try { b = typeof b === 'string' ? JSON.parse(b) : null; } catch (e) { b = null; }
  if (!b || Number(b.quantity) !== 0) return;
  let item = null;
  if (b.id) item = lastCart.items.find((it) => it.key === String(b.id) || it.variant_id === Number(b.id));
  else if (b.line) item = lastCart.items[Number(b.line) - 1];
  if (item && isGift(item)) setDismissed(qualifying(lastCart));
}

window.fetch = async function (input, init) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  const hdrs = init && init.headers;
  const ours = hdrs && (hdrs['X-NS-Gift'] || (typeof hdrs.get === 'function' && hdrs.get('X-NS-Gift')));
  const isCartMutation = !ours && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  if (!isCartMutation) return origFetch(input, init);
  if (/\/cart\/change/.test(url)) noteDismiss(init);

  const res = await origFetch(input, init);
  if (!res.ok) return res;
  let changed = false;
  try { changed = await reconcile(); } catch (e) {}
  if (!changed) return res;

  // Prezent dodany/usunięty: zwróć Horizon odpowiedź ze świeżymi sekcjami + danymi koszyka.
  try {
    const data = await res.clone().json();
    const ids = data && data.sections ? Object.keys(data.sections) : [];
    if (ids.length) data.sections = Object.assign({}, data.sections, await freshSections(ids));
    if (lastCart && Array.isArray(data.items) && 'item_count' in data) {
      const sections = data.sections;
      Object.assign(data, lastCart);
      if (sections) data.sections = sections;
    }
    const headers = new Headers(res.headers);
    headers.delete('content-length');
    return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers });
  } catch (e) {
    setTimeout(refreshUI, 0);
    return res;
  }
};

/* Boksy drabinki */
const NEXT = { 2: 'szczotkę do skóry owczej gratis', 3: 'darmową dostawę', 4: 'dodatkowe 10% rabatu' };
function cartMessage(q) {
  if (!GIFT_ON) {
    if (q <= 0) return '🛍️ Kup 2 produkty, a dostawę otrzymasz gratis';
    if (q === 1) return 'Jeszcze 1 produkt do 🚚 darmowej dostawy';
    if (q === 2) return '🚚 Darmowa dostawa zdobyta! Jeszcze 2 produkty do 💰 dodatkowych 10% rabatu';
    if (q === 3) return '🚚 Darmowa dostawa zdobyta! Jeszcze 1 produkt do 💰 dodatkowych 10% rabatu';
    return '🎉 Wszystkie korzyści aktywne: darmowa dostawa i 10% rabatu';
  }
  if (q <= 0) return '🛍️ Kup 2 produkty, a szczotkę do skóry owczej dostaniesz gratis';
  if (q === 1) return 'Jeszcze 1 produkt do 🎁 darmowej szczotki do skóry owczej';
  if (q === 2) return '🎁 Szczotka gratis zdobyta! Jeszcze 1 produkt do 🚚 darmowej dostawy';
  if (q === 3) return '🚚 Darmowa dostawa zdobyta! Jeszcze 1 produkt do 💰 dodatkowych 10% rabatu';
  return '🎉 Wszystkie korzyści aktywne: szczotka gratis, darmowa dostawa i 10% rabatu';
}
function updateLadder() {
  if (!lastCart) return;
  const q = qualifying(lastCart);
  document.querySelectorAll('[data-ns-ladder]').forEach((box) => {
    box.querySelectorAll('[data-step]').forEach((li) => li.classList.toggle('is-done', q >= Number(li.dataset.step)));
    const status = box.querySelector('[data-ladder-status]');
    if (!status) return;
    if (q === 0) { status.hidden = true; return; }
    status.hidden = false;
    if (q >= 4) { status.textContent = '🎉 Wszystkie korzyści są aktywne w Twoim koszyku!'; return; }
    const next = q < 2 ? 2 : (GIFT_ON ? q + 1 : 4);
    const NX = GIFT_ON ? NEXT : { 2: NEXT[3], 4: NEXT[4] };
    status.textContent = `Masz w koszyku ${q} ${q === 1 ? 'produkt' : (q % 10 >= 2 && q % 10 <= 4 && (q % 100 < 12 || q % 100 > 14)) ? 'produkty' : 'produktów'} – dodaj jeszcze ${next - q}, a otrzymasz ${NX[next]}.`;
  });
  document.querySelectorAll('[data-ns-cartladder]').forEach((box) => {
    const msg = box.querySelector('[data-cl-msg]');
    if (msg) msg.textContent = cartMessage(q);
    const fill = box.querySelector('[data-cl-fill]');
    if (fill) fill.style.width = `${(Math.min(q, 4) / 4) * 100}%`;
    box.querySelectorAll('[data-step]').forEach((li) => li.classList.toggle('is-done', q >= Number(li.dataset.step)));
  });
}

window.nsGift = { reconcile, updateLadder, refreshUI, openDrawer };
reconcile().then((changed) => { if (changed) refreshUI(); });
